import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnchor = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M120 -360V-480L280 -360L218 -298Q247 -247 310.0 -210.0Q373 -173 440 -163V-520H320V-600H440V-647Q405 -660 382.5 -690.5Q360 -721 360 -760Q360 -810 395.0 -845.0Q430 -880 480 -880Q530 -880 565.0 -845.0Q600 -810 600 -760Q600 -721 577.5 -690.5Q555 -660 520 -647V-600H640V-520H520V-163Q587 -173 650.0 -210.0Q713 -247 742 -298L680 -360L840 -480V-360Q840 -302 806.5 -251.0Q773 -200 721.0 -162.0Q669 -124 605.0 -102.0Q541 -80 480.0 -80.0Q419 -80 355.0 -102.0Q291 -124 239.0 -162.0Q187 -200 153.5 -251.0Q120 -302 120 -360ZM480 -720Q497 -720 508.5 -731.5Q520 -743 520 -760Q520 -777 508.5 -788.5Q497 -800 480 -800Q463 -800 451.5 -788.5Q440 -777 440 -760Q440 -743 451.5 -731.5Q463 -720 480 -720Z" })
});
export default SvgAnchor;
